import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpServiceService } from './http-service.service';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  public GetBranchesListDetailsURL="Ticket/GetBranchesListDetails";
  public SelectedBranchServicesURL="Ticket/SelectedBranchServices";
  public IssueTicketURL="Ticket/IssueTicket";
  public CheckVisitStatusURL="Ticket/CheckVisitStatus";
  public DeleteTicketURL="Ticket/DeleteTicket";


  constructor(private config:ConfigService,private http:HttpServiceService, private acc:AccountService
  )   { }


  BranchesListDetails(data,token){

    console.log("BranchesListDetailsReq",data)
    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.config.server+this.GetBranchesListDetailsURL,data,token).subscribe((res:any)=>{
        console.log("BranchesListDetails",res)
        resolve(res)

      },(Error)=>{
        console.log("BranchesListDetails",Error)
        resolve(Error);
      })

    })

  }


  
  SelectedBranchServices(data,token){

    console.log("SelectedBranchServicesReq",data)
    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.config.server+this.SelectedBranchServicesURL,data,token).subscribe((res:any)=>{
        console.log("SelectedBranchServices",res)
        resolve(res)

      },(Error)=>{
        resolve(Error);
      })

    })

  }

  
  IssueTicket(data,token){

    console.log("IssueTicketReq",data)
    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.config.server+this.IssueTicketURL,data,token).subscribe((res:any)=>{
        console.log("IssueTicket",res)
        resolve(res)

      },(Error)=>{
        resolve(Error);
      })
    })
  }

  CheckVisitStatus(data,token){

    console.log("CheckVisitStatusReq",data) 
    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.config.server+this.CheckVisitStatusURL,data,token).subscribe((res:any)=>{
        console.log("CheckVisitStatus",res)
        this.acc.CheckVstStatus = res?.response?.content;
        resolve(res)

      },(Error)=>{
        console.log("CheckVisitStatusError",Error)
        resolve(Error);

      })
    })
  }


  DeleteTicket(data,token){

    console.log("DeleteTicketReq",data)
    return new Promise((resolve,reject)=>{
      this.http.postToCloseApi(this.config.server+this.DeleteTicketURL,data,token).subscribe((res:any)=>{
        console.log("DeleteTicket",res)
        resolve(res)

      },(Error)=>{
        resolve(Error);
      })
    })
  }

}
